export default __webpack_public_path__ + "static/media/like_thumb.67d505a5.svg";